import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { FunctionComponent, useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from '../../../components/common/Button/Button';
import { Card, CardAction, CardText, CardTitle } from '../../../components/common/Card/Card';
import { FontAwesomeIcon } from '../../../components/common/FontAwesomeIcon/FontAwesomeIcon';
import { PageContainer } from '../../../components/common/PageContainer/PageContainer';
import { useBooking } from '../../../contexts/BookingProvider';
import { useBookingParams } from '../../../hooks/useBookingParams';
import { Stage } from '../../../model/stage';
import { useAuth } from '../../../services/auth/AuthProvider';
import classes from './LoginRequest.module.scss';

export const LoginRequest: FunctionComponent = () => {
    const booking = useBooking();
    const { formatMessage } = useIntl();
    const { user, signIn } = useAuth();
    const { stagePath, openStage } = useBookingParams();

    useEffect(() => {
        document.body.classList.add('white');
        return () => document.body.classList.remove('white');
    }, []);

    useEffect(() => {
        if (booking.details && user) {
            openStage(Stage.ConfirmBooking, booking.details, true);
        }
    }, [user, booking.details, openStage]);

    if (!booking.details) return null;

    const onBackClick = () => {
        openStage(Stage.EditBirthdayKids, booking.details);
    };

    const onLoginClick = () => {
        signIn(stagePath(Stage.ConfirmBooking, booking.details));
    };

    return (
        <PageContainer
            title={formatMessage({ id: 'login-request-booking.title', defaultMessage: 'Kalasbokningen snart klar' })}
            onBackClick={onBackClick}
        >
            <Card dark>
                <CardTitle>
                    <FormattedMessage
                        id="login-request.login-title"
                        defaultMessage="LOGGA IN PÅ DITT FAMILYKONTO FÖR ATT SLUTFÖRA KALASBOKNINGEN"
                    />
                </CardTitle>

                <CardText>
                    <FormattedMessage
                        id="login-request.login-text"
                        defaultMessage="Börja med att fylla i din e-postadress för att kolla om du redan har ett Familykonto. Har du inte det, så fixar vi ett konto i nästa steg. Via ditt Familykonto hanterar du sedan din kalasbokning, bjuder in gäster och annat skoj! Har du köpt en entrébiljett eller besökt oss tidigare så finns troligen ett Familykonto skapat för dig."
                    />
                </CardText>

                <CardAction>
                    <Button color="minionYellow" fullwidth onClick={onLoginClick}>
                        <FormattedMessage id="general.login" defaultMessage="Logga in" />
                        <FontAwesomeIcon icon={faArrowRight} width={16} className={classes.loginButtonIcon} />
                    </Button>
                </CardAction>
            </Card>
        </PageContainer>
    );
};
